import React, { createContext, useContext } from "react";

export enum ConversationConfigurationType {
  ASK = "ASK",
  ANSWER = "ANSWER",
  PUBLIC = "PUBLIC",
}

type ConversationConfiguration = {
  type: ConversationConfigurationType;
  user: {
    chatBubble: {
      className: string;
    };
  };
};

const ConversationConfigurationContext = createContext<
  ConversationConfiguration | undefined
>(undefined);

const map = {
  [ConversationConfigurationType.ASK]: {
    type: ConversationConfigurationType.ASK,
    user: {
      chatBubble: {
        className: "bg-[#cdffe3] text-neutral-900",
      },
    },
  },
  [ConversationConfigurationType.ANSWER]: {
    type: ConversationConfigurationType.ANSWER,
    user: {
      chatBubble: {
        className: "bg-[#e8eeff] text-neutral-900",
      },
    },
  },
  [ConversationConfigurationType.PUBLIC]: {
    type: ConversationConfigurationType.PUBLIC,
    user: {
      chatBubble: {
        className: "bg-primary-200 text-neutral-900",
      },
    },
  },
} as const;

export const ConversationConfigurationProvider: React.FC<
  React.PropsWithChildren<{ type: ConversationConfigurationType }>
> = ({ children, type }) => {
  return (
    <ConversationConfigurationContext.Provider value={{ ...map[type] }}>
      {children}
    </ConversationConfigurationContext.Provider>
  );
};

export const useConversationConfiguration = (): ConversationConfiguration => {
  const context = useContext(ConversationConfigurationContext);
  if (!context) {
    throw new Error(
      "useConversationConfiguration must be used within a ConversationConfigurationProvider",
    );
  }
  return context;
};
